import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'grid-ui-cell-renderer-ellipsis-tooltip',
  templateUrl: './cell-renderer-ellipsis-tooltip.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CellRendererEllipsisTooltipComponent implements ICellRendererAngularComp {
  @ViewChild('cellContainer', { read: ElementRef }) private readonly cellContainer?: ElementRef<HTMLSpanElement>;
  public displayValue = '';

  public get shouldDisableTooltip(): boolean {
    return (
      !this.displayValue ||
      (this.cellContainer?.nativeElement?.parentElement?.parentElement?.offsetWidth || 0) - 35 >
        (this.cellContainer?.nativeElement?.offsetWidth || 0)
    );
  }

  public refresh(): boolean {
    return false;
  }

  public agInit(params: ICellRendererParams): void {
    this.displayValue = params.valueFormatted ?? params.value;
  }
}
